const roundMoney = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return 0;
  return Math.round((n + Number.EPSILON) * 100) / 100;
};

const emptyTotals = () => ({
  totalAssetCost: 0,
  monthlyRecurring: 0,
  annualRecurring: 0,
  pricedAssetCount: 0,
  recurringAssetCount: 0,
  oneTimeAssetCount: 0,
  unannualizedCount: 0
});

/** Merge one or more budgeting groups (e.g. selected chassis types). */
export function mergeBudgetingGroups(groups) {
  const list = Array.isArray(groups) ? groups.filter(Boolean) : [];
  if (list.length === 0) {
    return { totals: emptyTotals(), months: [], byFrequency: [] };
  }

  const months = (list[0].months || []).map((month) => ({
    key: month.key,
    label: month.label,
    recurring: 0,
    oneTime: 0,
    total: 0
  }));
  const totals = emptyTotals();
  const frequencyMap = new Map();

  list.forEach((group) => {
    (group.months || []).forEach((month, index) => {
      if (!months[index]) return;
      months[index].recurring = roundMoney(months[index].recurring + (Number(month.recurring) || 0));
      months[index].oneTime = roundMoney(months[index].oneTime + (Number(month.oneTime) || 0));
      months[index].total = roundMoney(months[index].recurring + months[index].oneTime);
    });
    const t = group.totals || emptyTotals();
    totals.totalAssetCost = roundMoney(totals.totalAssetCost + (Number(t.totalAssetCost) || 0));
    totals.monthlyRecurring = roundMoney(totals.monthlyRecurring + (Number(t.monthlyRecurring) || 0));
    totals.annualRecurring = roundMoney(totals.annualRecurring + (Number(t.annualRecurring) || 0));
    totals.pricedAssetCount += Number(t.pricedAssetCount) || 0;
    totals.recurringAssetCount += Number(t.recurringAssetCount) || 0;
    totals.oneTimeAssetCount += Number(t.oneTimeAssetCount) || 0;
    totals.unannualizedCount += Number(t.unannualizedCount) || 0;
    (group.byFrequency || []).forEach((row) => {
      const existing = frequencyMap.get(row.frequency) || {
        frequency: row.frequency,
        count: 0,
        totalPrice: 0,
        monthlyRecurring: 0,
        annualRecurring: 0
      };
      existing.count += Number(row.count) || 0;
      existing.totalPrice = roundMoney(existing.totalPrice + (Number(row.totalPrice) || 0));
      existing.monthlyRecurring = roundMoney(existing.monthlyRecurring + (Number(row.monthlyRecurring) || 0));
      existing.annualRecurring = roundMoney(existing.annualRecurring + (Number(row.annualRecurring) || 0));
      frequencyMap.set(row.frequency, existing);
    });
  });

  return {
    totals,
    months,
    byFrequency: Array.from(frequencyMap.values())
  };
}
